// @ts-nocheck
import React, { useState, useRef, useEffect } from 'react';
import cn from 'classnames';
import Alert from '@shared/ui/alert/ui/Alert';

import { useAtomValue } from 'jotai';

import { subscriptionAtom } from '@shared/store/slice-atoms';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'react-bootstrap';
import { HeaderS } from '@shared/ui/header';
import { Footer } from '@shared/ui/footer';
import { changeLanguage } from '@entities/language/store';
import {
  unsubscribe,
  formResetComplete,
} from '@features/card-subscription/model/subscription-payment-flow';
import { Helpers } from '@shared/utils/Helpers';
import { setHtmlDirection } from '@shared/utils';
import { setTheme } from '@shared/utils/general';
import { APP_THEMES } from '@shared/config/constants/app';
import { Banner } from '@features/phone-subscription';
import { useQuery } from '@shared/hooks';
import { unsubBannerConfig } from '@shared/config/constants/Banners';

const Unsubscribe = ({ isArabic = false, languageConfig }) => {
  const { query } = useQuery();
  const { t, i18n } = useTranslation();
  const formStartRef = useRef(null);
  const howItWorksRef = useRef(null);

  const { btnLoading, needToResetForm } = useAtomValue(subscriptionAtom);

  const queryEmail = query.get('email') || '';
  const querySubscriberId = query.get('subscriberId') || '';

  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    setEmail(queryEmail);
  }, [queryEmail]);

  const handleEmail = (e) => {
    if (queryEmail) return;

    const text = e.target.value;
    setErrorMessage('');
    setEmail(text);
    if (text.length > 0 && text.length < 255 && Helpers.isEmail(text)) {
      let newErrors = { ...errors };
      delete newErrors.email;
      setErrors(newErrors);
    } else {
      setErrors({ ...errors, email: t('error_email') });
    }
  };

  useEffect(() => {
    if (isArabic) {
      let lang = { locale: 'ar', displayName: 'العربية', direction: 'rtl' };
      i18n.changeLanguage(lang.locale);
      changeLanguage(lang);
      setHtmlDirection('rtl');
    }

    setTheme(APP_THEMES.WHITE);
  }, []);

  useEffect(() => {
    if (needToResetForm) {
      setEmail('');
      formResetComplete();
    }
  }, [needToResetForm]);

  const handleSubmitUnsubscribe = (e) => {
    e.preventDefault();
    if (errors.email || email === '') {
      setErrorMessage('Invalid email');
      return;
    } else {
      setErrorMessage('');
    }
    unsubscribe({ email, subscriberId: querySubscriberId });
  };

  return (
    <article className="landing-article">
      <HeaderS
        formStartRef={formStartRef}
        howItWorksRef={howItWorksRef}
        languageConfig={languageConfig}
        isCC
      />
      <Banner bannerConfig={unsubBannerConfig} />
      <Container className="container-sm">
        <section className="landing-section-4">
          <form onSubmit={handleSubmitUnsubscribe}>
            <Row className="mt-3">
              <Col>
                <p className="teleport-subtitle">{t('enter_email_to_unsubscribe')}</p>
              </Col>
            </Row>

            <Row>
              <Col xs={12}>
                <label className="vuz-label-1">{t('email')}</label>
                <p className="error-label">{errors.email && t('error_email')}</p>
                <input
                  className={cn('vuz-input-2', errors.email && 'input-error', 'mb-2')}
                  name="email"
                  placeholder={t('enter_email')}
                  autoComplete="new-email"
                  onChange={handleEmail}
                  value={email}
                />
              </Col>
            </Row>

            <div className="text-center mb-3">
              <Alert />
              {errorMessage && <p className="error-message">{errorMessage}</p>}

              <button
                id="unsubscribe-button"
                type="submit"
                className="vuz-btn-1 large lh-07 mt-2 join-btn-confirm"
              >
                <span className="subscribe-btn-txt">
                  {btnLoading ? (
                    <>
                      <i className="fas fa-circle-notch fa-spin sm-icon-margin-1" />
                      {t('processing')}
                    </>
                  ) : (
                    t('unsubscribe')
                  )}
                </span>
              </button>
              <br />
              <br />
            </div>
          </form>
          <Footer
            isWhite
            hideFeatures
            isOTP
            vipFeaturesConfig={{ hide: true }}
            followUsConfig={{ hide: true }}
            moreAboutUsConfig={{ hide: true }}
            aboutUsConfig={{ hide: true }}
          />
        </section>
      </Container>
    </article>
  );
};

export { Unsubscribe };
